var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"regulations-container"},[_c('div',{staticClass:"regulations-content",domProps:{"innerHTML":_vm._s(_vm.richTextContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }